import common from './common'
import debugHelper from '../../util/debug'
import { IncomingMessage } from 'http'


var fs = {
	/**
	 * 获取文件Token
	 * @param {*} vm
	 * @param {*} funcList
	 */
	funcFetchFSToken: function (vm, funcList) {
		console.log('调试代码')
		//获取文件Token
		debugHelper.log('funcFetchFSToken : 获取文件Token')
		var JWT = vm.getAccountToken()
		vm.fetchFsToken({
			vm: vm,
			authorization: { Authorization: `Bearer ${JWT}` }
		}).then(
			() => {
				debugHelper.log('mFetchFsToken => success')
				common.callNextFunc(vm, funcList)
			},
			() => {
				debugHelper.log('mFetchFsToken => failure')
			}
		)
	},

	/**
	 * 上传图片文件
	 * @param {*} vm
	 * @param {*} funcList
	 */
	funcPutFS: function (vm, funcList) {
		debugHelper.log('funcPutFS : 上传文件')

		funcList = funcList[0].setParams(funcList)

		var img = funcList[0].params.img

		var b64toBlob = require('b64-to-blob')
		var contentType = 'image/jpg'
		var blob = b64toBlob(img.split(',')[1], contentType)
		var formdata = new FormData()
		formdata.append('file1', blob, 'image.jpg')

		vm.putFs({
			token: vm.getFstoken(),
			formdata: formdata,
			vm: vm
		}).then(
			res => {
				debugHelper.log(res)

				//图片上传完毕后更新订单信息

				funcList[0].params.res = res
				funcList[0].getResult(funcList)

				common.callNextFunc(vm, funcList)
			},
			err => {
				//alert("failure");
				debugHelper.log('failed')
			}
		)
	},
	/**
	 * 上传图片文件列表
	 * @param {*} vm
	 * @param {*} funcList
	 */
	funcPutFSList: function (vm, funcList) {
		debugHelper.log('funcPutFSList : 上传图片文件列表')

		funcList = funcList[0].setParams(funcList)
		debugHelper.log(funcList)

		var imgs = funcList[0].params.imgs
		var resList = []
		var i = 0

		if (imgs.length == 0) {
			funcList[0].params.resList = resList
			funcList[0].getResult(funcList)
			common.callNextFunc(vm, funcList)
		} else {
			imgs.forEach(img => {
				var b64toBlob = require('b64-to-blob')
				var type = img.split(';')[0].split(':')[1]

				var contentType = type
				debugHelper.log(contentType)
				var blob = b64toBlob(img.split(',')[1], contentType)
				var formdata = new FormData()
				if (type == 'video/mp4') {
					formdata.append('file1', blob, 'video.mp4')
				} else {
					formdata.append('file1', blob, 'image.jpg')
				}

				vm.putFs({
					token: vm.getFstoken(),
					formdata: formdata,
					vm: vm
				}).then(
					res => {
						debugHelper.log(res)
						resList.push(res)
						if (++i == imgs.length) {
							funcList[0].params.resList = resList
							funcList[0].getResult(funcList)
							common.callNextFunc(vm, funcList)
						}
					},
					err => {
						//alert("failure");
						debugHelper.log('failed')
					}
				)
			})
		}
	},

	/**
	 * 删除文件
	 * @param {*} vm
	 * @param {*} funcList
	 */
	funcDelFS: function (vm, funcList) {
		debugHelper.log('funcDelFS: 删除文件')

		funcList = funcList[0].setParams(funcList)

		var picNo = funcList[0].params.picNo
		var picUri = funcList[0].params.picUri

		//删除照片
		vm.delFs({
			token: vm.getFstoken(),
			uri: picUri(picNo),
			vm: vm
		}).then(
			res => {
				debugHelper.log(res)

				//图片删除后更新信息
				funcList[0].params.res = res
				funcList[0].getResult(funcList)
				common.callNextFunc(vm, funcList)
			},
			err => {
				//alert("failure");
				debugHelper.log('delFs failed')
			}
		)
	}
}

export default fs
